<template v-if="selectedTripPattern">
    <component
        :is="tripPatternDetailsComponent"
        v-model="selectedTripPattern"
        v-model:expanded="selectedTripPatternIdIsExpanded"
        :destination="searchResult.trip?.to"
        :loading="bookingIsLoadingMessage"
        :now="mainStore.currentTime"
        @click:back="goBackToList"
    >
        <template v-if="showBookingCard" #searchResultContentPrepend>
            <div class="pt-6 px-4 px-md-8">
                <booking-combo-card class="pt-6 pb-4 px-4" />
            </div>
        </template>

        <template v-if="selectedTripPattern" #searchResultContentAppend>
            <div class="pb-6 px-4">
                <share-trip-dialog :trip-pattern="selectedTripPattern" />
            </div>
        </template>
    </component>
</template>

<script setup lang="ts">
import { useBookingStore } from '@/features/bookings/stores';
import { storeToRefs } from 'pinia';
import { computed, provide, watch } from 'vue';
import { BookingComboCard } from '@/features/bookings/components';
import { useBookingCard, useBookingFormCard } from '@/features/bookings/composables';
import { useI18n } from 'vue-i18n';
import { setupTripSearchDetails } from './setupTripSearchDetails';
import { useMainStore } from '@/features/common/stores';
import { BookingCardProvideKey, BookingFormCardProvideKey, OnlineBookingIsAvailableKey } from '@/injectionKeys';
import { ShareTripDialog } from '@/features/trips/components';

const { t } = useI18n();
const {
    searchResult,
    selectedTripPattern,
    selectedTripPatternId,
    selectedTripPatternIdIsExpanded,
    tripPatternDetailsComponent,
    goBackToList
} = setupTripSearchDetails();
const mainStore = useMainStore();
const bookingStore = useBookingStore();
const { bookingIsEnabled, onlineBookingIsAvailable, isLoading } = storeToRefs(bookingStore);
const showBookingCard = computed(() => bookingIsEnabled.value && onlineBookingIsAvailable.value);
const { init } = useBookingFormCard();
const bookingIsLoadingMessage = computed(() => (isLoading.value ? t('booking.resources.loadingBookingsData') : false));

provide(OnlineBookingIsAvailableKey, onlineBookingIsAvailable);
provide(BookingFormCardProvideKey, useBookingFormCard());
provide(BookingCardProvideKey, useBookingCard());

// set up watcher to reset booking state when trip pattern details is accessed
watch(
    selectedTripPatternId,
    async value => {
        if (value) {
            await init();
        }
    },
    { immediate: true }
);
</script>
